// @ts-nocheck
import { createContext } from 'react';
const CustomFormContext = createContext([{ state: {}, actions: {} }]);
export default CustomFormContext;
